module.exports = __webpack_public_path__ + "static/media/sensor-alert.201b80ab.svg";